import React from "react";
import Back from "../components/Back";
const Notfound = () => {
  return (
    <div>
      <Back />
      <h3>Not found</h3>
    </div>
  );
};

export default Notfound;
